<template>
	<div class="breadcrumb" v-if="mappedItems.length">
		<span
			class="breadcrumb__item"
			:key="index"
			v-for="(item, index) in mappedItems"
		>
			<span class="breadcrumb__divider" v-if="index === 0 && showFirstDivider">
				{{ firstDivider }}
			</span>
			<span class="breadcrumb__divider" v-if="index !== 0">{{
				divider
			}}</span>
			<router-link
				:id="`breadcrumbId${index}`"
				class="link breadcrumb__link"
				v-if="hasUrlLink(item)"
				:to="toUrl(item)"
				>{{ item.name }}
			</router-link>
			<slot v-else>{{ item.name }}</slot>
		</span>
	</div>
</template>

<script>
import { isEmpty } from '@/utils/object';
import _ from 'lodash';
export default {
	name: 'Breadcrumbs',
	props: {
		items: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			divider: '>',
			firstDivider: '<'
		};
	},
	computed: {
		mappedItems() {
			let newItems = _.cloneDeep(this.items);
			if (this.items.length == 2) {
				const routes = newItems.map((route, index) => {
					if (index === 0) {
						route.name = 'Back to ' + route.name;
					}
					return route;
				});
				return routes;
			}
			return newItems;
		},
		showFirstDivider(){
			return this.mappedItems.some(obj => obj.name.includes('Back to'));
		}
	},
	methods: {
		toUrl(item) {
			const { url, path, data } = item;

			const extractedUrl = url || path || data;

			if (extractedUrl && typeof extractedUrl === 'string') {
				return { path: extractedUrl };
			}

			if (!isEmpty(extractedUrl) && typeof extractedUrl === 'object') {
				return { ...extractedUrl };
			}

			return { path: '/' };
		},
		hasUrlLink(item) {
			return item.url || item.path || item.data;
		}
	}
};
</script>

<style lang="scss">
/**
    * [Description]
    *
    * Breadcrumb Styles
    * Can use SCSS variables = TRUE
 */

.breadcrumb {
	font-size: $default-font-size - 4;
	display: flex;
	flex-flow: row wrap;
	row-gap: $gutter-sm;
	align-items: baseline;

	&__divider {
		display: inline-block;
		margin: 0 $gutter-sm;
	}
}
</style>
